export default "__VITE_ASSET__tBiCKGSG__"